var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01IdleBlink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{animation:bob 3.2s ease-in-out infinite}\n@keyframes bob{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n#eyeL{transform-origin:90px 115px;animation:blink 4.5s infinite}\n#eyeR{transform-origin:150px 115px;animation:blink 4.5s infinite}\n@keyframes blink{0%,90%,100%{transform:scaleY(1)}94%{transform:scaleY(.08)}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 160,
    height: 150,
    rx: 52,
    fill: "#6FE3D0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eyeL",
    cx: 90,
    cy: 115,
    r: 13,
    fill: "#0E2A2E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eyeR",
    cx: 150,
    cy: 115,
    r: 13,
    fill: "#0E2A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 150 Q120 167 139 150",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01IdleBlink);
export default __webpack_public_path__ + "static/media/01-idle-blink.a885d5b68e94f5ca4359fea2b15ef53f.svg";
export { ForwardRef as ReactComponent };